import { ImportExportHistoriesColumn } from '@/features/import_export_histories/type';
import { useTranslation } from '@/i18n';

export const useStatusLabel = (
  status: ImportExportHistoriesColumn['status']
) => {
  const { t } = useTranslation();

  switch (status) {
    case 'processing':
      return t('import_export_history_status_processing');
    case 'completed':
      return t('import_export_history_status_done');
    case 'failed':
      return t('import_export_history_status_failed');
    case 'canceled':
      return t('import_export_history_status_canceled');
    default:
      return '';
  }
};
